export type ProcessingTrigger = (typeof ProcessingTrigger)[keyof typeof ProcessingTrigger];

export const ProcessingTrigger = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
} as const;
